<div class="">
  <mat-card class="p-4 mb-3">
    <h3 class="my-0 font-weight--500 d-flex mb-3">
      <mat-icon fontSet="material-symbols-outlined">filter_alt</mat-icon>&nbsp;Filters & Zoeken
    </h3>
    <div class="d-flex flex-wrap gap-2">
      <!-- Search -->
      <mat-form-field appearance="outline" class="no-subscript search-form-field">
        <mat-label>Zoek in titel, nummer, beschrijving...</mat-label>
        <input [formControl]="searchQueryInput" matInput placeholder="Zoek in titel, nummer, beschrijving" value="">
      </mat-form-field>

      <!-- Neighbourhood -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Wijk</mat-label>
        <mat-select [formControl]="neighbourhoodSelect" multiple>
          @for (neighbourhood of neighbourhoodList; track neighbourhood.id) {
            <mat-option [value]="neighbourhood">{{ neighbourhood.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Theme -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Thema</mat-label>
        <mat-select [formControl]="storyThemeSelect" multiple>
          @for (storyTheme of storyThemeList; track storyTheme.id) {
            <mat-option [value]="storyTheme">{{ storyTheme.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Tag -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Trefwoord</mat-label>
        <mat-select [formControl]="tagSelect" multiple>
          @for (tag of storyTagList; track tag.id) {
            <mat-option [value]="tag">{{ tag.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Status -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="statusSelect">
          <mat-option [value]="''">Alle statussen</mat-option>
          <mat-option [value]="StoryStatus.PUBLISHED">Gepubliceerd</mat-option>
          <mat-option [value]="StoryStatus.NOT_PUBLISHED">Concept</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Date filter -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Van</mat-label>
        <input matInput [matDatepicker]="pickerFrom" [formControl]="dateFrom" [max]="dateUntil.value">
        <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Tot</mat-label>
        <input matInput [matDatepicker]="pickerUntil" [formControl]="dateUntil" [min]="dateFrom.value">
        <mat-datepicker-toggle matIconSuffix [for]="pickerUntil"></mat-datepicker-toggle>
        <mat-datepicker #pickerUntil></mat-datepicker>
      </mat-form-field>

      <!-- Is project -->
      <div class="d-flex align-items-center mr-2">
        <mat-checkbox [formControl]="isProjectCheckbox">Project</mat-checkbox>
      </div>

      <!-- Is active -->
      <div class="d-flex align-items-center mr-2">
        <mat-checkbox [formControl]="isActiveCheckbox">Active</mat-checkbox>
      </div>

      <!-- Reset -->
      <div class="d-flex align-items-center">
        <button mat-stroked-button (click)="clearFilters()">Wis filters</button>
      </div>
    </div>
  </mat-card>


  <mat-card class="p-4">
    <div class="d-flex flex-row justify-content-between">
      <!-- Title -->
      <div class="d-flex flex-column mb-3">
        <h3 class="my-0 font-weight--500 d-flex">
          <mat-icon fontSet="material-symbols-outlined">news</mat-icon>&nbsp;Verhalen Overzicht
        </h3>
        <span class="text-muted">{{ dataSource.total$ | async }} verhalen gevonden</span>
      </div>
      <div>

        <input
          type="file"
          accept="text/csv"
          #fileInput
          hidden
          (change)="onFileSelected(fileInput)"
        />

        <!-- Crate new story -->
        <button matButton="outlined" class="mr-2" (click)="fileInput.click()">
          <mat-icon>add</mat-icon>
          Upload CSV
        </button>

        <!-- Crate new story -->
        <button matButton="filled" routerLink="/create-edit-story">
          <mat-icon>add</mat-icon>
          Nieuw Verhaal
        </button>

      </div>
    </div>


    <!-- Table -->
    <!-- Loader -->
    <div class="progress-bar-container">
      @if (dataSource.loading$ | async) {
        <mat-progress-bar
          mode="indeterminate"
        ></mat-progress-bar>
      }
    </div>
    <!-- End loader -->
    <div class="list-container">
      <table mat-table [dataSource]="dataSource" class="w-100">

        <!-- ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID</th>
          <td mat-cell *matCellDef="let story">
            <span class="font-weight--500">{{ story.collectionNumber }}</span>
          </td>
        </ng-container>

        <!-- Title -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-column">
              <span>Title</span>
              <span class="text-muted">Description</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let story">
            <div class="d-flex flex-column my-1">
              <span class="font-weight--500 mb-1">{{ story.title }}</span>
              <span class="text-muted">{{ story.shortDescription }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Author -->
        <ng-container matColumnDef="author">
          <th mat-header-cell *matHeaderCellDef>
            Publicatie
          </th>
          <td mat-cell *matCellDef="let story">
            <div class="d-flex flex-column">
              <span class="font-weight--500">{{ story.user?.name }}</span>
              <span class="text-muted">{{ story.createdAt | date:'dd/MM/yy' }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Area -->
        <ng-container matColumnDef="area">
          <th mat-header-cell *matHeaderCellDef> Area</th>
          <td mat-cell *matCellDef="let story"> {{ story.neighbourhood?.name }}</td>
        </ng-container>

        <!-- Thema -->
        <ng-container matColumnDef="thema">
          <th mat-header-cell *matHeaderCellDef>Thema's</th>
          <td mat-cell *matCellDef="let story">
            <mat-chip-set aria-label="Theme list">
              @for (theme of story.themeList; track theme.id) {
                <mat-chip>{{ theme.name }}</mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Tags -->
        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef> Tags</th>
          <td mat-cell *matCellDef="let story">
            <mat-chip-set aria-label="Tag list">
              @for (tag of story.tagList; track tag.id) {
                <mat-chip>{{ tag.name }}</mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Project -->
        <ng-container matColumnDef="isProject">
          <th mat-header-cell *matHeaderCellDef>Project</th>
          <td mat-cell *matCellDef="let story">
            @if (story.isProject === true) {
              <mat-icon fontSet="material-symbols-outlined" class="text-success">check</mat-icon>
            }
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let story">
            @if (story.status === StoryStatus.PUBLISHED) {
              <mat-icon
                fontSet="material-symbols-outlined"
                class="text-success"
                matTooltip="Gepubliceerd"
              >visibility</mat-icon>
            } @else {
              <mat-icon
                fontSet="material-symbols-outlined"
                matTooltip="Concept"
              >visibility_off</mat-icon>
            }
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let story">
            <div class="d-flex gap-2 justify-content-end story-list-actions">
              <button
                matIconButton
                matTooltip="Bewerken"
                aria-label="Verhaal bewerken"
                [routerLink]="`/create-edit-story/${story.id}`"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                matIconButton
                class="danger-button"
                matTooltip="Verwijderen"
                aria-label="Verhaal verwijderen"
                (click)="deleteStory(story, $event)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Header + Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          class="story-list-row"
          *matRowDef="let row; columns: displayedColumns;"
        ></tr>

      </table>

      <!-- Paginator -->
      <mat-paginator
        class="w-100"
        pageSize="10"
        [length]="(dataSource.paginatedData$ | async)?.total"
        [pageSize]="(dataSource.paginatedData$ | async)?.size"
        [pageSizeOptions]="[10, 20, 25, 50, 100]"
        showFirstLastButtons
      ></mat-paginator>
    </div>

  </mat-card>
</div>
